<template lang="pug">
  b-container(fluid)
    b-row.align-items-center
      b-col(md="6")
        b-form-group.mb-0(:description="cards.length ? '' : 'Crea la primer tarjeta dando click en Crear tarjeta'")
          b-button(variant="success", :disabled="loading", @click="createCard", block)
            b-spinner(small, variant="light", v-if="loading", type="grow")
            span(v-else) Crear tarjeta
    b-row.mt-3(v-if="cards.length")
      b-col(lg="6", v-for="card in cards", :key="card.bmessaging_card_id")
        b-card.my-2.no-shadow
          b-form-group(label="Título")
            b-form-input(placeholder="Título", v-model="card.title")
          b-form-group(label="Mensaje")
            b-form-input(placeholder="Mensaje", v-model="card.text")
          b-form-group(label="Imagen de cabecera")
            img-input(:src="card.image", @click="changeImage(card)", size="lg")
          b-form-row(v-if="!card.type")
            b-col
              b-button(variant="light", block, @click="addButton(card, 'postback')" :disabled="loading") + Conector
            b-col
              b-button(variant="light", block, @click="addButton(card, 'web_url')" :disabled="loading") + Botón web
          b-input-group(v-else)
            b-form-input(placeholder="Título de botón", v-model="card.button_title", trim)
            b-input-group-append
              block-connector(:flow_id="card.flow_id", important-only, :next_block_id="card.next_block", :type="card.type", :url="card.url", buttonOnly, @change="updateConnector(card, $event)")
            b-input-group-append
              b-button(variant="soft-danger", @click="updateConnector(card)")
                trash-2-icon.icon-sm

          b-form-row.mt-3
            b-col
              b-button(variant="soft-success", @click="updateCard(card)", block) Guardar
            b-col(cols="auto")
              b-button(variant="soft-danger", @click="deleteCard(card.bmessaging_card_id)")
                trash-2-icon.icon-sm

    input(type="file", accept="image/*", style="display:none;", ref="input_image", @change="imagePicked")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import { UploadFile } from '@/helpers/upload-file'
import { toBase64 } from '@/helpers/file-converter'
import ImgInput from '@/components/img-input'
const accountController = createNamespacedHelpers('account')
const cardsController = createNamespacedHelpers('bmessaging_card')

export default {
  computed: {
    ...accountController.mapGetters(['selectedLanguage']),
    /*...cardsController.mapState({
      cards: state => state.bmessaging_cards,
    }),*/
  },
  data () {
    return {
      loading: false,
      selected_card: null,
      cards: []
    }
  },
  props: {
    bmessaging_id: {
      default: null
    }
  },
  methods: {
    ...mapActions(['bmessaging_card/all', 'bmessaging_card/create', 'bmessaging_card/update', 'bmessaging_card/destroy', 'block/get', 'helpers/upload_file']),
    getCards () {
      let self = this
      this.loading = true

      this['bmessaging_card/all']({
        account_id: self.$route.params.account_id,
        bmessaging_id: self.bmessaging_id,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.cards = res.resource.map(c => {
              c[c.type === 'web_url' ? 'url' : 'next_block'] = c.payload
              if(c.type == 'postback') this.getFlowID(c)
              c.file_image = null
              return c
            })
          }
        }
      })
    },
    getFlowID (element) {
      if(!element.next_block) return null

      let self = this
      self['block/get']({
        block_id: element.next_block,
        params: {
          platform: 'bmessaging',
          language_id: self.selectedLanguage
        },
        callback: res => {
          if (res.error) {
            this.$message.error(res.error)
          } else {
            element.flow_id =  res.resource.flow_id
          }
        }
      })
    },
    createCard () {
      let self = this
      this.loading = true

      let empty_card = {
        title: 'Nueva tarjeta',
        text: '',
        type: null,
        payload: null,
        button_title: '',
        image: '',
        bmessaging_id: this.bmessaging_id
      };

      this['bmessaging_card/create']({
        ...empty_card,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.cards.push(res.resource)
          }
        }
      })
    },
    addButton  (card, type) {
      card.type = type
      card[type == 'web_url' ? 'url' : 'next_block'] = null
      if(type == 'postback') card.flow_id = null
      this.updateCard(card)
    },
    updateConnector (card, data) {
      if(card.type == 'postback') card.flow_id = data ? data.flow_id : null
      card[card.type == 'web_url' ? 'url' : 'next_block'] = data ? (card.type == 'web_url' ? data.url : data.next_block_id) : null
      card.type = data ? card.type : null
      this.updateCard(card)
    },
    async updateCard (card) {
      let self = this
      this.loading = true

      if(card.file_image) {
        try {
          card.image = await UploadFile.call(this, card.file_image)
        } catch (e) {
          console.log(e)
          card.image = ''
          this.$message.warning('No pudimos subir la imagen, por favor verifica tu conexión a internet')
        }
      }

      card.payload = card.type == 'web_url' ? card.url : card.next_block
      this['bmessaging_card/update']({
        ...card,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            card.file_image = null
            self.$message.success('Tarjeta actualizada')
          }
        }
      })
    },
    async uploadFile (file) {
      let self = this
      return new Promise (async (resolve, reject) => {
        let params = {
          file_name: file.name,
          mime: file.type
        }

        try {
          if (file.name.includes('.'))
            params.file_extension = file.name.split('.').slice(-1)
        } catch (e) {
          console.log(e.message)
        }

        try {
          let fileBase64 = await toBase64(file, true)
          params.file = fileBase64
        } catch (e) {
          console.log(e.message)
          reject(new Error('Error cargando archivo'))
        }

        self['helpers/upload_file']({
          ...params,
          callback: res => {
            if (res.error) {
              reject(new Error(res.error))
            } else {
              resolve(res.resource.url)
            }
          }
        })
      })
    },
    deleteCard (bmessaging_card_id) {
      if(this.loading) return
      let self = this
      this.loading = true

      this['bmessaging_card/destroy']({
        bmessaging_card_id: bmessaging_card_id,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            let index = self.cards.findIndex(c => c.bmessaging_card_id == bmessaging_card_id)
            if (index >= 0) {
              self.cards.splice(index, 1)
            }
          }
        }
      })
    },
    changeImage (card) {
      if(!card.image.length) {
        this.selected_card = card
        this.$refs.input_image.click()
      } else {
        card.image = ''
      }
    },
    imagePicked (event) {
      let file = event.target.files[0]
      this.selected_card.file_image = file
      this.selected_card.image = URL.createObjectURL(file)
      this.$refs.input_image.value = ''
    },
  },
  mounted () {
    this.getCards()
  },
  components: { ImgInput }
}
</script>

<style lang="scss" scoped>
</style>
